import React from "react"
import { LAMP_MAP, SHELTER_LAMP_MAP } from "../../Utils/lamp"
import { CrowdLamp } from "../types"

import * as styles from "./Styles/CrowdLampSwitch.module.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

const Switch: React.FC<{
  color: string
  message: string
  onClick: any
  active: boolean
}> = ({ color, message, onClick, active }) => (
  <React.Fragment>
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault()
        onClick(color)
      }}
      className={styles.lampSwitch}
    >
      <div
        className={cn(
          "lamp",
          active || color === "turnedOff" ? "lamp--active" : "lamp--inactive",
          `lamp--${color}`
        )}
      >
        <span>{message}</span>
      </div>
    </a>
  </React.Fragment>
)

const Switches: React.FC<{
  onClick: any
  lamp: CrowdLamp
  isShelter: boolean
}> = ({ onClick, lamp, isShelter }) => {
  const lamp_map = isShelter ? SHELTER_LAMP_MAP : LAMP_MAP

  return (
    <div style={{ textAlign: "center" }}>
      <div className={cn("lamps", lamp ? "lamps--withDescription" : "")}>
        {Object.keys(lamp_map).map((color, i) => (
          <Switch
            key={i}
            color={color}
            message={
              color === "turnedOff" ? "情報なし" : lamp_map[color].message
            }
            onClick={onClick}
            active={lamp ? lamp.color === color : true}
          />
        ))}
      </div>
      {lamp && (
        <div>
          {lamp.endedAt ? lamp.endedAt : "次の操作"}
          まで表示されます
        </div>
      )}
    </div>
  )
}

const CrowdLampSwitch: React.FC<{
  onClick: any
  lamp: CrowdLamp
  available: boolean
  isShelter: boolean
}> = ({ onClick, lamp, available, isShelter }) => {
  return (
    <React.Fragment>
      {available && (
        <Switches lamp={lamp} onClick={onClick} isShelter={isShelter} />
      )}
      {!available && <div>お使いいただけません</div>}
    </React.Fragment>
  )
}

export default CrowdLampSwitch
